<div [formGroup]="form">
  <div class="row">
    <div class="col-12 col-lg-8">
      <app-multi-select-button-group [fieldsEnum]="Weekdays"
                                     id="weekdays"
                                     [form]="form"
                                     [translateKey]="'i18n.domain.import-configuration.enums.weekdays.'">
      </app-multi-select-button-group>
    </div>
    <div class="col-12 col-lg-4 mt-2 mt-lg-0">
      <div class="e-btn-group">
        <input type="button"/>
        <label class="e-btn"
               [ngClass]="{'e-btn-active': weekdaysActive(), 'disabled': areWeekdaysDisabled()}"
               (click)="selectWeekdays()">
          {{ 'i18n.domain.import-configuration.edit.time-scedule.workdays' | translate}}
        </label>
        <input type="button"/>
        <label class="e-btn"
               [ngClass]="{'e-btn-active': weekendActive(), 'disabled': areWeekendsDisabled()}"
               (click)="selectWeekend()">
          {{ 'i18n.domain.import-configuration.edit.time-scedule.weekend' | translate}}
        </label>
        <input type="button"/>
        <label class="e-btn"
               [ngClass]="{'e-btn-active': allActive(), 'disabled': areAllDaysDisabled()}"
               (click)="selectAll()">
          {{ 'i18n.domain.import-configuration.edit.time-scedule.all' | translate}}
        </label>
      </div>
    </div>
  </div>
</div>
